import React, { Component } from "react";
import PropTypes from "prop-types";

import SignUpView from "features/application/sign-up/view";

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.referrerReference = React.createRef();
  }

  render() {
    const {
      currentStep,
      errorCodes,
      urlUserId,
      formReference,
      sendApiRequest,
    } = this.props;

    return (
      <SignUpView
        currentStep={currentStep}
        errorCodes={errorCodes}
        urlUserId={urlUserId}
        formReference={formReference}
        referrerReference={this.referrerReference}
        sendApiRequest={sendApiRequest}
      />
    );
  }
}

SignUp.propTypes = {
  currentStep: PropTypes.string,
  errorCodes: PropTypes.object,
  urlUserId: PropTypes.string,
  formReference: PropTypes.object,
  sendApiRequest: PropTypes.func,
};

export default SignUp;
